"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _formatPrice = _interopRequireDefault(require("../../../utils/formatPrice"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _TotalPrice = _interopRequireDefault(require("./TotalPrice.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TotalPrice = _ref => {
  let {
    lang,
    prices
  } = _ref;
  const css = (0, _TotalPrice.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const totalPrice = (0, _react.useMemo)(() => {
    if ((0, _isEmpty.default)(prices)) return [];
    return prices.find(_ref2 => {
      let {
        type
      } = _ref2;
      return type === "total";
    });
  }, [prices]);
  if ((0, _isEmpty.default)(prices)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.totalPrice, "mco-shop-cart-total-price")
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.label, "mco-shop-cart-total-price__label")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.cart.labels.prices.total",
    l: l
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.taxLabel, "mco-shop-cart-total-price__tax-label")
  }, (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.priceOption) === "netto" ? /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.labels.taxNetto",
    l: l
  }) : /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.labels.taxBrutto",
    l: l
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.value, "mco-shop-cart-total-price__value")
  }, (0, _formatPrice.default)(totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.amount)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.taxValue, "mco-shop-cart-total-price__tax-value")
  }, (0, _formatPrice.default)(totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.taxPrice))));
};
var _default = exports.default = TotalPrice;